// extracted by mini-css-extract-plugin
export default {"block":"kn","info":"ln","error":"mn","noSpace":"nn","optional":"on"};